import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

const USE_MOCK = false;

const MOCK_CONFIG = {
  id: 1,
  qrOrderingEnabled: true,
  requireStaffApproval: false,
  autoActivateSession: true,
  sessionTimeoutHours: 2,
  maxOrdersPerSession: 10,
  baseUrl: 'https://menu.maverickdine.com',
  createdAt: '2026-01-15T10:00:00Z',
  updatedAt: '2026-02-10T14:30:00Z',
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const qrConfigService = {
  async getConfig() {
    if (USE_MOCK) {
      await delay(500);
      return { ...MOCK_CONFIG };
    }
    return apiClient.get(ENDPOINTS.QR_CONFIG.GET);
  },

  async createConfig(data) {
    if (USE_MOCK) {
      await delay(600);
      return { ...MOCK_CONFIG, ...data, id: 1, createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() };
    }
    return apiClient.post(ENDPOINTS.QR_CONFIG.CREATE, data);
  },

  async updateConfig(data) {
    if (USE_MOCK) {
      await delay(600);
      return { ...MOCK_CONFIG, ...data, updatedAt: new Date().toISOString() };
    }
    return apiClient.put(ENDPOINTS.QR_CONFIG.UPDATE, data);
  },

  async toggleOrdering() {
    if (USE_MOCK) {
      await delay(400);
      MOCK_CONFIG.qrOrderingEnabled = !MOCK_CONFIG.qrOrderingEnabled;
      return { qrOrderingEnabled: MOCK_CONFIG.qrOrderingEnabled };
    }
    return apiClient.put(ENDPOINTS.QR_CONFIG.TOGGLE_ORDERING);
  },

  async deleteConfig() {
    if (USE_MOCK) {
      await delay(400);
      return { success: true };
    }
    return apiClient.delete(ENDPOINTS.QR_CONFIG.DELETE);
  },
};

export default qrConfigService;
